<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fluid" :class="{ 'white-bg': scrollPosition > 100, 'hide-dropdown': dropdownHidden, 'light-header': useLightHeader }">
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img src="@/assets/img/logo_white.png"><div>天烨智芯</div>
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li  v-for="(item,index) in navList"  :key="index" :class="index==navIndex?'active':scrollPosition > 100?'blk-color':''" @click="navClick(index)">
          <router-link :to="item.path">
            {{item.name}}
          </router-link>
          <div class="header-bl" v-if="item.children.length>0" @click.stop>
            <div class="header-main">
              <div v-for="(i,n) in item.children" :key="n" class="header-c">
                <div class="header-title">{{i.name}}</div>
                <div v-for="(m,s) in i.children" :key="s" class="header-name">
                  <router-link :to="m.path" @click.native="onSubNavClick">{{m.name}}</router-link>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fluid visible-xs">
      <!-- 导航栏 -->
      <div class="header-nav-m-top">
        <div class="header-nav-m-logo">
          <img src="@/assets/img/logo_white.png"><span>天烨智芯</span>
        </div>
        <div class="header-nav-m-menu-wrapper" @click="menuClick">
          <span :class="menuClass"></span>
        </div>
      </div>

      <!-- 导航内容 -->
      <ul id="menu" class="header-nav-m-wrapper collapse" :class="{ 'show': isMenuOpen }">
        <li v-for="(item,index) in navList" :key="index"  :class="index==navIndex?'active':scrollPosition > 100?'blk-color':''"  >
          <div class="header-title" @click.stop="toggleSubMenu(index)">
            <div v-if="!item.children.length"  @click="navClick1(item.path)">
              {{item.name}}
            </div>
            <span v-else>
              {{item.name}}
              <i :class="subMenuOpen[index] ? 'glyphicon glyphicon-menu-up' : 'glyphicon glyphicon-menu-down'"></i>
            </span>
          </div>

          <div v-if="item.children.length && subMenuOpen[index]" class="sub-menu">
            <div v-for="(i,n) in item.children" :key="n" class="header-c">
              <div class="header-subtitle">{{i.name}}</div>
              <div v-for="(m,s) in i.children" :key="s" class="header-name"  @click="navClick1(m.path)">
                {{m.name}}
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { WOW } from 'wowjs';
export default {
  name: "Header",
  data() {
    return {
      navIndex: sessionStorage.getItem('navIndex') ? parseInt(sessionStorage.getItem('navIndex')) : 0,
      menuClass: "glyphicon glyphicon-menu-down",
      scrollPosition: 0,
      isMenuOpen: false,
      subMenuOpen: {}, // 用于控制子菜单展开状态
      dropdownHidden: false, // 控制桌面下拉菜单隐藏
      navList: [
        {
          name: "首页",
          path: "/",
          children: []
        },
        {
          name: "核心技术",
          path: "/CoreTechnology",
          children: []
        },
        {
          name: "产品中心",
          path: "/",
          children: [
            {
              name: 'AI芯片',
              children: [
                { path: '/T10', name: 'T10' }
              ]
            },
            {
              name: '开发套件',
              children: [
                { path: '/DB10', name: 'DB10' },
                { path: '/TM10', name: 'TM10' }
              ]
            },
            {
              name: '硬件产品',
              children: [
                { path: '/CUBE10', name: 'CUBE10' }
              ]
            }
          ]
        },
        {
          name: "解决方案",
          path: "/",
          children: [
            {
              name: '智能驾驶',
              children: [
                { path: '/Scheme1', name: '激光雷达点云智驾感知方案' },
                { path: '/Scheme2', name: '双目智驾参考方案' },
                { path: '/Scheme3', name: '轻量级行泊一体参考方案' },
                { path: '/Scheme4', name: '高阶行泊一体参考方案' },
                { path: '/Scheme5', name: '驾驶员/乘员监测方案' }
              ]
            },
            {
              name: '电力行业',
              children: [
                { path: '/transmission', name: '智慧输电线路巡检方案' },
                { path: '/substation', name: '智慧变电站 AI巡检系统方案' },
                { path: '/distribution', name: '配电站房人工智能可视化网关方案' }
              ]
            },
            {
              name: '垂直行业',
              children: [
                { path: '/ks', name: '矿山井下 AI服务器方案' },
                { path: '/city', name: '智慧城市解决方案' }
              ]
            },
            {
              name: '硬件参考方案',
              children: [
                { path: '/SchemeNe100', name: 'TY-BD10 参考方案' },
                { path: '/SchemeTm10', name: 'TM10 参考方案' }
              ]
            },
          ]
        },
        {
          name: "关于我们",
          path: "/contactus",
          children: []
        }
      ]
    };
  },
  computed: {
    useLightHeader() {
      const lightRoutes = [
        'companyintroduction',
        'contactus',
        'aidc',
        'newsinformation',
        'servicedetail'
      ];
      const name = (this.$route.name || '').toString().toLowerCase();
      return lightRoutes.indexOf(name) > -1 && this.scrollPosition <= 100;
    }
  },
  methods: {
    // 根据当前路由路径自动匹配 navIndex
    updateNavIndexFromRoute(path) {
      const currentPath = path || this.$route.path;
      // 精确匹配或检查子路由
      const index = this.navList.findIndex(item => {
        if (item.children.length === 0) {
          return item.path === currentPath;
        }
        // 有子菜单的：检查所有层级的子路径
        return item.children.some(c =>
          c.path === currentPath ||
          (c.children && c.children.some(sub => sub.path === currentPath))
        );
      });
      if (index !== -1) {
        this.navIndex = index;
        sessionStorage.setItem('navIndex', index);
      }
    },
    navClick(index) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex', index);
      this.$router.push(this.navList[index].path);
      this.closeMenu();
    },
    navClick1(path) {
      this.updateNavIndexFromRoute(path);
      this.$router.push(path);
      this.closeMenu();
    },
    menuClick() {
      this.isMenuOpen = !this.isMenuOpen;
      this.menuClass = this.isMenuOpen ? "glyphicon glyphicon-menu-up" : "glyphicon glyphicon-menu-down";
    },
    closeMenu() {
      this.isMenuOpen = false;
      this.menuClass = "glyphicon glyphicon-menu-down";
      // 重置所有子菜单状态
      Object.keys(this.subMenuOpen).forEach(key => {
        this.subMenuOpen[key] = false;
      });
    },
    toggleSubMenu(index) {
      // 如果没有子菜单则不处理
      if (!this.navList[index].children.length) return;

      // 切换当前子菜单状态
      this.subMenuOpen[index] = !this.subMenuOpen[index];

      // 关闭其他子菜单
      Object.keys(this.subMenuOpen).forEach(key => {
        if (parseInt(key) !== index) {
          this.subMenuOpen[key] = false;
        }
      });
    },
    handleScroll() {
      this.scrollPosition = window.scrollY;
    },
    // 点击二级菜单后隐藏下拉，防止菜单不消失
    onSubNavClick() {
      this.dropdownHidden = true;
      setTimeout(() => { this.dropdownHidden = false; }, 300);
    }
  },
  mounted() {
    // 初始根据当前路由设置选中状态
    this.updateNavIndexFromRoute();

    // 初始化子菜单状态
    this.navList.forEach((_, index) => {
      this.$set(this.subMenuOpen, index, false);
    });

    // 组件挂载后添加滚动监听
    window.addEventListener('scroll', this.handleScroll);

    // 初始化wowjs动画
    new WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 100,
      mobile: true,
      live: true
    }).init();
  },
  // 监听路由变化，自动更新选中状态
  watch: {
    $route(to) {
      this.updateNavIndexFromRoute(to.path);
    }
  },
  beforeDestroy() {
    // 组件销毁前移除滚动监听，防止内存泄漏
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>

<style scoped>
/* 移除所有 a 标签的焦点轮廓（点击后不出现框） */
a:focus, a:active, a:focus-visible {
  outline: none;
}

/* ============================================
   导航栏容器 — 大气沉稳
   ============================================ */
.container-fluid {
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 9999;
  background: transparent;
  transition: all 0.5s cubic-bezier(0.22, 1, 0.36, 1);
}

.white-bg {
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(20px) saturate(1.3);
  -webkit-backdrop-filter: blur(20px) saturate(1.3);
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.06);
}

/* ============================================
   桌面端导航 — 96px 挺拔身姿
   ============================================ */
.header-nav {
  height: 96px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: height 0.35s ease;
}

/* ----------  Logo 区域  ---------- */
.header-nav-logo {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
}

.header-nav-logo img {
  width: 140px;
  height: auto;
  transition: all 0.35s ease;
}

.header-nav-logo div {
  color: #fff;
  font-size: 1.45rem;
  font-weight: 700;
  letter-spacing: 3px;
  transition: color 0.35s ease;
}

.white-bg .header-nav-logo div {
  color: #0f1a2e;
}

/* .light-header .header-nav-logo div {
  color: #0f1a2e;
} */

/* ----------  导航列表  ---------- */
.header-nav-wrapper {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  align-items: center;
  gap: 2px;
}

.header-nav-wrapper > li {
  height: 96px;
  line-height: 96px;
  position: relative;
  cursor: pointer;
}

.header-nav-wrapper > li > a {
  display: inline-block;
  color: rgba(255, 255, 255, 0.88);
  font-size: 17px;
  font-weight: 500;
  padding: 0 24px;
  text-decoration: none;
  transition: all 0.3s ease;
  letter-spacing: 0.8px;
  position: relative;
  line-height: normal;
  vertical-align: middle;
}

/* 有子菜单的导航项 — 小箭头指示 */
.header-nav-wrapper > li:has(> .header-bl) > a::after {
  content: '';
  display: inline-block;
  width: 7px;
  height: 7px;
  border-right: 2px solid currentColor;
  border-bottom: 2px solid currentColor;
  transform: rotate(45deg) translateY(-4px);
  margin-left: 7px;
  transition: transform 0.3s ease;
  opacity: 0.6;
}

.header-nav-wrapper > li:has(> .header-bl):hover > a::after {
  transform: rotate(-135deg) translateY(-1px);
  opacity: 1;
}

/* 滚动后文字颜色 */
.white-bg .header-nav-wrapper > li > a {
  color: rgba(20, 30, 50, 0.82);
}

/* .light-header .header-nav-wrapper > li > a {
  color: rgba(15, 26, 46, 0.86);
} */

/* -----  悬停状态 — 仅变色无框  ----- */
.header-nav-wrapper > li:hover > a {
  color: #2391FF;
}

/* -----  激活状态  — 仅加深颜色  ----- */
.header-nav-wrapper > li.active > a {
  color: #2391FF !important;
  font-weight: 600;
}

/* ============================================
   桌面端下拉菜单 — 大气卡片
   ============================================ */
.header-bl {
  display: block;
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%) translateY(12px);
  min-width: 680px;
  white-space: nowrap;
  z-index: 10000;
  background: rgba(255, 255, 255, 0.98);
  border-radius: 16px;
  box-shadow:
    0 20px 60px rgba(0, 0, 0, 0.14),
    0 8px 20px rgba(0, 0, 0, 0.06),
    0 1px 4px rgba(0, 0, 0, 0.04);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.5);

  /* 悬停桥梁 */
  padding-top: 18px;
  margin-top: -18px;

  /* 显隐控制 */
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: all 0.3s cubic-bezier(0.22, 1, 0.36, 1);
}

/* 悬停触发下拉 — 带轻微的上升回弹感 */
.header-nav-wrapper > li:hover .header-bl {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  transform: translateX(-50%) translateY(6px);
}

/* 点击二级菜单后强制隐藏下拉 */
#header.hide-dropdown .header-bl {
  opacity: 0 !important;
  visibility: hidden !important;
  pointer-events: none !important;
}

/* 下拉菜单内容网格 */
.header-main {
  display: flex;
  justify-content: flex-start;
  padding: 28px 24px 24px;
  gap: 12px;
  flex-wrap: wrap;
  max-width: 900px;
  margin: 0 auto;
}

.header-c {
  min-width: 170px;
  max-width: 240px;
  flex: 1;
}

/* 分组标题 */
.header-bl .header-title {
  font-size: 15px;
  font-weight: 600;
  color: #0f1a2e;
  line-height: 42px;
  margin-bottom: 6px;
  padding: 0 14px 0 20px;
  letter-spacing: 0.5px;
  position: relative;
  display: inline-block;
  border-bottom: 1.5px solid #eef2f6;
}

/* 分组标题左侧装饰条 */
.header-bl .header-title::before {
  content: '';
  position: absolute;
  left: 6px;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 18px;
  background: linear-gradient(180deg, #2391FF, #6BB5FF);
  border-radius: 2px;
}

/* 子项 */
.header-name {
  padding: 2px 14px;
}

.header-name a {
  color: #555;
  text-decoration: none;
  font-size: 14px;
  line-height: 36px;
  display: block;
  transition: all 0.25s ease;
  border-radius: 6px;
  padding: 0 10px;
  margin: 0 -10px;
  font-weight: 400;
  letter-spacing: 0.3px;
}

.header-name a:hover {
  color: #2391FF;
  background: rgba(35, 145, 255, 0.06);
  padding-left: 16px;
  font-weight: 500;
}

/* 兼容旧类名 */
.header-nav-wrapper > li.blk-color > a {
  color: rgba(20, 30, 50, 0.82);
}

/* ============================================
   移动端导航 — 深色科技感
   ============================================ */
.header-nav-m {
  background: linear-gradient(135deg, #0f1a2e 0%, #1a2744 100%);
}

.header-nav-m-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  padding: 0 18px;
}

.header-nav-m-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #fff;
  font-size: 1.15rem;
  font-weight: 600;
  letter-spacing: 2px;
}

.header-nav-m-logo img {
  width: 40px;
  height: auto;
}

.header-nav-m-menu-wrapper {
  color: #fff;
  font-size: 22px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  transition: background 0.2s;
}

.header-nav-m-menu-wrapper:hover {
  background: rgba(255, 255, 255, 0.08);
}

/* 移动端菜单面板 */
.header-nav-m-wrapper {
  list-style: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.45s cubic-bezier(0.22, 1, 0.36, 1);
}

.header-nav-m-wrapper.show {
  max-height: 700px;
  transition: max-height 0.55s cubic-bezier(0.22, 1, 0.36, 1);
}

.header-nav-m-wrapper > li {
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.header-nav-m-wrapper > li > a,
.header-title span {
  color: rgba(255, 255, 255, 0.85);
  display: block;
  padding: 16px 20px;
  text-decoration: none;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s;
  letter-spacing: 0.5px;
}

.header-nav-m-wrapper > li > a:hover,
.header-title span:hover {
  color: #6BB5FF;
}

.header-nav-m-wrapper .header-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* 子菜单 */
.sub-menu {
  background: rgba(0, 0, 0, 0.2);
  padding: 8px 0 14px 24px;
}

.header-subtitle {
  color: rgba(255, 255, 255, 0.5);
  padding: 12px 14px 6px;
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.sub-menu .header-name {
  padding: 0;
}

.sub-menu .header-name a {
  color: rgba(255, 255, 255, 0.75);
  display: block;
  padding: 10px 14px;
  text-decoration: none;
  font-size: 14px;
  border-radius: 6px;
  transition: all 0.2s;
}

.sub-menu .header-name a:hover {
  color: #fff;
  background: rgba(35, 145, 255, 0.15);
  padding-left: 18px;
}

/* 移动端选中状态 */
.header-nav-m-wrapper > li.active {
  background: rgba(35, 145, 255, 0.08);
  border-left: 3px solid #2391FF;
}

/* ============================================
   响应式适配
   ============================================ */
@media screen and (max-width: 768px) {
  .container-fluid {
    left: 0;
    width: 100%;
  }

  .header-nav-logo div {
    font-size: 1.2rem;
  }

  .header-nav-wrapper > li > a {
    font-size: 14px;
    padding: 0 12px;
  }
}

@media screen and (min-width: 769px) and (max-width: 1024px) {
  .header-nav-wrapper > li > a {
    font-size: 15px;
    padding: 0 14px;
    letter-spacing: 0.5px;
  }

  .header-nav-logo img {
    width: 120px;
  }

  .header-main {
    padding: 24px 16px 20px;
    gap: 8px;
  }

  .header-c {
    min-width: 140px;
    max-width: 200px;
  }

  .header-bl {
    min-width: 560px;
  }
}

@media screen and (max-width: 420px) {
  .header-nav-logo img {
    width: 100px;
  }

  .header-nav-logo div {
    font-size: 1rem;
    letter-spacing: 1.5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue